import { ListAlt, LocalMall, LocalOffer, People, Redeem, Stars, Store } from '@material-ui/icons';

import FHSLogo from 'components/logos/fhs';
import { FIREHOUSE_SUBS_DARK_RED } from 'state/theme/colors';

import { IBrandConfigs } from './brand-config';
import { routes } from '../utils/routing';

const fhsConfigs: IBrandConfigs = {
  links: [
    {
      name: 'Customers',
      route: routes.customer,
      Icon: People,
    },
    {
      name: 'Orders',
      route: routes.orders,
      Icon: LocalMall,
    },
    {
      name: 'Support History',
      route: routes.supportHistory,
      Icon: ListAlt,
    },
    {
      name: 'Gift Cards',
      route: routes.giftCard,
      Icon: Redeem,
    },
    {
      name: 'Offers',
      route: routes.offersLD,
      Icon: LocalOffer,
    },
    {
      name: 'Loyalty',
      route: routes.ctgLoyalty,
      Icon: Stars,
    },
    {
      name: 'Stores',
      route: routes.store,
      Icon: Store,
    },
  ],
  Logo: FHSLogo,
  theme: {
    brandColor: FIREHOUSE_SUBS_DARK_RED,
  },
  ctgLoyaltyEnabled: true,
  hasPhysicalCtgLoyaltyCard: false,
  loyaltyPointsIssuanceRange: {
    USA: {
      min: 1,
      max: 1500,
      step: 1,
    },
    CAN: {
      min: 1,
      max: 1500,
      step: 1,
    },
    DEFAULT: {
      min: 1,
      max: 1500,
      step: 1,
    },
  },
  loyaltyPointsPerCurrency: {
    USA: 100,
    CAN: 100,
    DEFAULT: 100,
  },
  allowPointsOnLoyaltyTab: {
    USA: true,
    CAN: true,
    DEFAULT: true,
  },
};

export default fhsConfigs;
